<script setup lang="ts">
</script>

<template>
  <div class="card animate-pulse" role="status" aria-live="polite">
    <span class="sr-only">Loading...</span>
    <!-- Image placeholder -->
    <div class="aspect-square bg-gray-700 rounded-lg mb-4"></div>
    <!-- Name placeholder -->
    <div class="h-6 bg-gray-700 rounded w-3/4 mb-2"></div>
    <!-- Nickname placeholder -->
    <div class="h-4 bg-gray-700 rounded w-1/2 mb-3"></div>
    <!-- Tags placeholder -->
    <div class="flex flex-wrap gap-2">
      <div class="h-6 bg-gray-700 rounded w-20"></div>
      <div class="h-6 bg-gray-700 rounded w-16"></div>
      <div class="h-6 bg-gray-700 rounded w-14"></div>
    </div>
  </div>
</template>
